var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-shipping-progress"},[_c('div',{staticClass:"cart-shipping-progress__bar-holder"},[_c('div',{staticClass:"cart-shipping-progress__bar-progress",class:{
        'cart-shipping-progress__bar-progress--qualify':
          _vm.getPercentageProgress >= 100
      },style:({ width: `${_vm.getPercentageProgress}%` })},[_c('div',{staticClass:"cart-shipping-progress__shipping-icon"},[_c('bleach-image',{key:_vm.iconSrc,staticClass:"cart-shipping-progress__shipping-icon-image",class:{
            'cart-shipping-progress__shipping-icon-image--product': _vm.isProduct
          },attrs:{"src":_vm.iconSrc,"default-size":[50, 'ar_1'],"imageQuality":"60"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }